import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação do Bootstrap
import { Modal } from 'react-bootstrap';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class StaffsPendenciaTab extends Component {

  // Constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      'dados': [],
      'dados_modal_materias': [],
      'titulo_modal_treinamento': [],
      'modal': false,
    };
    this.showModal = this.showModal.bind(this);
    this.botaoView = this.botaoView.bind(this);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.pendencias)) {
      this.setState({dados: newProps.pendencias});
    }
  }

  showModal(event) {
    var target = event.currentTarget.value;
    var url = config.get('api') + '/alunos/treinamento/titulo/'+target;
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({titulo_modal_treinamento: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });

    var url_materias = config.get('api') + '/alunos/treinamento_materias_pendentes/'+target;

    Promise.resolve(header).then(function(value) {
      fetch(url_materias, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({dados_modal_materias: responseJson.data, modal: true});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  botaoView (cell, row) {
    var variavel = (
      <button className="btn btn-info btn-sm" value={cell} onClick={this.showModal}>
          <i className="fa fa-fw fa-eye"></i>
      </button>
    );

    return variavel;
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Treinamentos Pendentes</h3>
  <hr/>
  <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há treinamentos ministrados para este instrutor'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>
    
    <TableHeaderColumn isKey={true} dataField="treinamento" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Treinamento</TableHeaderColumn>

    <TableHeaderColumn dataField="turma" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Turma</TableHeaderColumn>

    <TableHeaderColumn dataField="date_start" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data Inicial</TableHeaderColumn>

    <TableHeaderColumn dataField="date_finish" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data Final</TableHeaderColumn>

    <TableHeaderColumn dataField="url_modal_materias" dataAlign="center" dataFormat={this.botaoView} width='80'>Ações</TableHeaderColumn>

  </BootstrapTable>

  <Modal show={this.state.modal} bsSize="large" aria-labelledby="contained-modal-title-lg">
    <Modal.Header>
        <h4 className="pull-left">Matérias Pendentes - {this.state.titulo_modal_treinamento.turma_nome + " - " + this.state.titulo_modal_treinamento.treinamento_nome}</h4>
        <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
        <i className="fa fa-fw fa-close"></i></button>
        <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <BootstrapTable data={this.state.dados_modal_materias} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

        <TableHeaderColumn isKey={true} dataField="materia" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Matéria</TableHeaderColumn>

        
        <TableHeaderColumn dataField="date_start" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data Inicial</TableHeaderColumn>

        <TableHeaderColumn dataField="date_finish" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data Final</TableHeaderColumn>

        <TableHeaderColumn dataField="status" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Status</TableHeaderColumn>
      </BootstrapTable>
    </Modal.Body>
    <Modal.Footer>
        <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false })}>
        <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default StaffsPendenciaTab;



// WEBPACK FOOTER //
// ./src/Components/Staffs/Elements/StaffsPendenciaTab.js